/// <reference path="./locationfilter.tsx" />
import * as React from 'react';
import {ViewTypes} from '../model/ui';
import {LocationFilterLevel} from '../model/geo';
import LocationFilter, {LocationFilterProps} from './locationfilter';
import {Button,Glyphicon} from 'react-bootstrap';
import {connect} from 'react-redux';


export interface SubheadingProps {
    title: string | any;
    selectedViewType?: ViewTypes;
    setViewType?: (newViewType: ViewTypes) => void;
    locationFilter?: LocationFilterProps;
    children?: any;
    user?: any;
}

export enum SubheadingItemLocations {
    LEFT,RIGHT
}
export interface SubheadingItemProps {
    location: SubheadingItemLocations;
    children?: any;
}

// by default components will be to the right

export class SubheadingItem extends React.Component<SubheadingItemProps, any> {
    render () {
        return this.props.children;
    }

}
export class Subheading extends React.Component<SubheadingProps, any> {
    render() {
        let controlList = this.props.children, controls = null;
        // Single child isn't an array by default.
        let leftControlList = [];
        let rightControlList = [];
        React.Children.forEach(controlList, (control: any) => {
            if (control.props.location == SubheadingItemLocations.LEFT)
                leftControlList.push(control);
            else
                rightControlList.push(control);
        });

        if (rightControlList) {
            controls = (
                    <div className="col-xs-11 col-md-9 controls-wrapper">
                        <div className="controls">
                            {rightControlList}
                        </div>
                </div>
            );
        }

        return (
            <div className="row page-heading">
                <div className="col-xs-12 col-md-3 title">
                    <h2>{this.props.title}</h2>
                </div>
                <div className="col-xs-1 col-md-2">
                    {leftControlList}
                </div>
                {controls}
            </div>
        );
    }
}
